import React, { FC } from 'react';
import { ContainerLarge as Container } from '../../components/base/grid';
import Settings from '../../components/myPost/settings';
import pageWrapper from '../../hoc/pageWrapper';
import IMyShipmentsViewModel from '../../interfaces/myShipments/myShipments';

interface Props {
	page: IMyShipmentsViewModel;
}

const MyShipmentsSettings: FC<Props> = ({ page }) => {
	return (
		<Container>
			<Settings page={page} />
		</Container>
	);
};

export default pageWrapper(MyShipmentsSettings);
